import { Button, Stack } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function LoginButtons() {
  const navigate = useNavigate();
  return (
    <Stack direction="row" gap={3}>
      <Button onClick={() => navigate('/register')} variant="outlined">
        Register
      </Button>
      <Button onClick={() => navigate('/login')} variant="contained">
        {' '}
        Login
      </Button>
    </Stack>
  );
}
